/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentNoteText/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Author from './Author/index'
import NoteHtml from 'DesignSystem/NoteHtml/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AppointmentNoteText({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/AdditionalOptions/Content/Notes/Content/AppointmentNoteText"
  
}) {
let noteNoteValueData = fromData.useDataValue({ viewPath,
context: 'note',
path: 'note',
})
let dtTypographyFontsizeMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.mm'
        })
  return (<React.Fragment
>
<Author
  viewPath={`${viewPath}/Author`}
/>
<NoteHtml
  viewPath={`${viewPath}/NoteHtml`}
 fontSize={dtTypographyFontsizeMm}
 data="note.note"
 html={noteNoteValueData}
/>
{children}
</React.Fragment>)
}